// extracted by mini-css-extract-plugin
export default {"rankingScoreCell":"RankingScoreCell_rankingScoreCell__i23JY","rankingScoreNumber":"RankingScoreCell_rankingScoreNumber__jwkTk","digit":"RankingScoreCell_digit__xsQDk"};